// extracted by mini-css-extract-plugin
export default {"title":"free-beds-view_title__XaE3P","header":"free-beds-view_header__LZHGf","result":"free-beds-view_result__66A7n","label-warning":"free-beds-view_label-warning__BlPKS"};